import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d7909de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DescriptionComponent = _resolveComponent("DescriptionComponent")!
  const _component_TriangleImages = _resolveComponent("TriangleImages")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DescriptionComponent)
    ]),
    _createVNode(_component_TriangleImages)
  ], 64))
}